import type { ReactNode } from 'react';
import { useCallback } from 'react';

import type { FormAsyncComboboxProps } from '@/_components';
import { FormAsyncCombobox, PrimaryLink } from '@/_components';

import { useGetBrandsMutation } from '../apis';
import type { BrandQueryLinkerSchema } from '../schemas';

export function BrandsAsyncSelect({ disabled, ...props }: FormAsyncComboboxProps<BrandQueryLinkerSchema>) {
  const getName = useCallback(
    (item?: BrandQueryLinkerSchema | null): ReactNode => {
      if (!item) {
        return '';
      }

      const itemName = item.name;

      if (!disabled) {
        return itemName;
      }

      return (
        <PrimaryLink to="/settings/brands/$id" params={{ id: `${item.id}` }} state={{ naturalBack: true }}>
          {itemName}
        </PrimaryLink>
      );
    },
    [disabled]
  );

  return (
    <FormAsyncCombobox
      {...props}
      itemToString={getName}
      keyExtractor={(item) => item?.id?.toString?.() ?? null}
      useApi={useGetBrandsMutation}
      disabled={disabled}
    />
  );
}
